"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fieldType_1 = __importDefault(require("../fieldType"));
const isInteger_1 = __importDefault(require("lodash/isInteger"));
const Errors_1 = __importDefault(require("../Errors"));
const number_1 = __importDefault(require("./number"));
exports.default = (0, fieldType_1.default)({
    name: 'integer',
    validate(value, info) {
        if (!(0, isInteger_1.default)(value))
            return Errors_1.default.NOT_AN_INTEGER;
        return number_1.default.validate(value, info);
    }
});
